import React, { useEffect, useState, useRef } from 'react';
import { motion, useAnimation, useMotionValue, useTransform } from 'framer-motion';
import { ChevronRight, Check } from 'lucide-react';
interface SwipeButtonProps {
  onClaim: () => void;
  claimed?: boolean;
}
export function SwipeButton({
  onClaim,
  claimed = false
}: SwipeButtonProps) {
  const [isClaimed, setIsClaimed] = useState(claimed);
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const controls = useAnimation();
  const x = useMotionValue(0);
  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth);
    }
    const handleResize = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleDragEnd = (event: any, info: any) => {
    const threshold = containerWidth * 0.6;
    if (info.offset.x > threshold) {
      setIsClaimed(true);
      controls.start({
        x: containerWidth - 56
      }); // 56 is the width of the draggable knob
      onClaim();
    } else {
      controls.start({
        x: 0
      });
    }
  };
  const backgroundOpacity = useTransform(x, [0, containerWidth * 0.8], [0, 1]);
  const textOpacity = useTransform(x, [0, containerWidth * 0.4], [1, 0]);
  if (isClaimed) {
    return <div className="w-full h-14 bg-[#4ade80] rounded-full flex items-center justify-center text-[#070709] font-bold text-lg shadow-[0_0_15px_rgba(74,222,128,0.4)]" data-id="element-28">
        <Check className="w-6 h-6 mr-2" data-id="element-29" />
        Task Claimed
      </div>;
  }
  return <div ref={containerRef} className="relative w-full h-14 bg-[#1a1a24] rounded-full overflow-hidden flex items-center border border-[#2a2a35]" data-id="element-30">
      <motion.div className="absolute inset-0 bg-[#4ade80] origin-left" style={{
      opacity: backgroundOpacity
    }} data-id="element-31" />

      <motion.div className="absolute w-full text-center font-semibold text-[#a0a0ab] pointer-events-none z-10" style={{
      opacity: textOpacity
    }} data-id="element-32">
        Swipe to claim
      </motion.div>

      <motion.div drag="x" dragConstraints={{
      left: 0,
      right: containerWidth - 56
    }} dragElastic={0.1} onDragEnd={handleDragEnd} animate={controls} style={{
      x
    }} className="absolute left-1 w-12 h-12 bg-[#4ade80] rounded-full flex items-center justify-center cursor-grab active:cursor-grabbing z-20 shadow-md" data-id="element-33">
        <ChevronRight className="w-6 h-6 text-[#070709]" data-id="element-34" />
      </motion.div>
    </div>;
}